<template>
  <div id="user">
    <!-- <button class="logout" @click="onLogout()">logout</button> -->
    <header>
      <div class="ef--inner first">
        <h1>
          <img src="/assets/images/common/logo.png" alt="きゅうでん電気予報" />
        </h1>
        <ul class="first">
          <li v-if="isShowAlertCurrPower || isShowAlertMaxPower">
            電衛門
          </li>
          <li v-if="isShowAlertCurrPower">
            <span class="status" v-bind:class="$store.state.alertLevelClass" v-if="($store.state.airConditionerIdFlag == true)">
              <span v-if="$store.state.alertLevelClass == 'level1'">未制御</span>
              <span v-if="$store.state.alertLevelClass == 'level2'">注意制御</span>
              <span v-if="$store.state.alertLevelClass == 'level3'">限界制御</span>
            </span>
            <span class="status" v-bind:class="$store.state.alertLevelClass" v-else>
              <span v-if="$store.state.alertLevelClass == 'level1'">良 好</span>
              <span v-if="$store.state.alertLevelClass == 'level2'">注 意</span>
              <span v-if="$store.state.alertLevelClass == 'level3'">警 報</span>
            </span>
            現在値/予測値
            <p>{{ currentPower }}/{{ demandPower }}</p>
            <span class="kw">kW</span>
          </li>
          <li v-if="isShowAlertMaxPower">
            <span class="status" v-bind:class="$store.state.maxPowerClass">
              <span v-if="$store.state.maxPowerClass == 'level1'">良 好</span>
              <span v-if="$store.state.maxPowerClass == 'level2'">注 意</span>
              <span v-if="$store.state.maxPowerClass == 'level3'">警 報</span>
            </span>
            日最大
            <p>{{ maxPower }}</p>
            <span class="kw">kW</span>
          </li>
        </ul>
      </div>
      <nav>
        <div class="ef--inner">
          <div class="nav-area">
            <ul>
              <li>
                <a href="javascript:void(0);" @click="$router.push('/')">
                  <img src="/assets/images/common/menu.icon1.png" />
                  <span>HOME</span>
                </a>
              </li>
              <li>
                <a
                  href="javascript:void(0);"
                  @click="$router.push('/monitoring')"
                >
                  <img src="/assets/images/common/menu.icon2.png" />
                  <span>電気使用・天気実績</span>
                </a>
              </li>
              <li>
                <a href="https://kisho.wni.co.jp" target="_blank">
                  <img src="/assets/images/common/menu.icon3.png" />
                  <span>一般気象</span>
                </a>
              </li>
              <li>
                <a
                  href="javascript:void(0);"
                  @click="$router.push('/realtime')"
                >
                  <img src="/assets/images/common/menu.icon4.png" />
                  <span>電力リアルタイム</span>
                </a>
              </li>
              <li>
                <a v-bind:href="generalToolUrl" target="_blank">
                  <img src="/assets/images/common/menu.icon5.png" />
                  <span>省エネツール</span>
                </a>
              </li>
              <li v-if="isAirConditionerControl == true">
                <a href="javascript:void(0);" @click="$router.push('/air_conditioner_monitoring')">
                  <img src="/assets/images/common/menu.icon6.png" />
                  <span>空調自動制御監視</span>
                </a>
              </li>
            </ul>
            <div class="user">
              <span>{{ username }}さま</span>
              <a v-if="this.$store.state.loginType != 3" href="javascript:void(0); " @click="$router.push('/setting')"
                >お客さま設定</a
              >
              <a href="javascript:void(0);" @click="onLogout()">ログアウト</a>
            </div>
          </div>
          <div class="panel">
            <div class="menu-trigger">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </nav>
    </header>
    <router-view />
    <footer>
      <div class="ef--inner">
        <p>
          Copyright (c) KYUSHU ELECTRIC POWER CO., INC. All Rights Reserved.
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
export default {
  name: "user",
  computed: {
    generalToolUrl() {
      if (this.$store.state.childInfo == null) {
        return "";
      }
      if (this.$store.state.childInfo.power_info.general_tool_url == null) {
        return "";
      }
      return this.$store.state.childInfo.power_info.general_tool_url;
    },
    username() {
      const obj = this.$store.state.childInfo;
      return obj != null ? obj.base_info.company_name : "";
    },
    currentPower: function() {
      return this.$store.state.currentPower;
    },
    demandPower: function() {
      return this.$store.state.demandPower;
    },
    maxPower: function() {
      return this.$store.state.maxPower;
    },
    isShowAlertCurrPower: function() {
      if(this.$store.state.childInfo != null
          && this.$store.state.childInfo.power_info['measure_instrument'] == 2 
          && typeof(this.$store.state.currentPower) == 'undefined' 
          && typeof(this.$store.state.demandPower) == 'undefined'){
            return false;
          }
      return true;
    },
    isShowAlertMaxPower: function() {
      if(this.$store.state.childInfo != null
          && this.$store.state.childInfo.power_info['measure_instrument'] == 2 
          && (typeof(this.$store.state.maxPower) == 'undefined' || this.$store.state.maxPower == 0)){
            return false;
          }
      return true;
    },
    isAirConditionerControl: function() {
      if ((this.$store.state.childInfo != null) &&
          (this.$store.state.childInfo.power_info['air_conditioner_control'] == true)) {
            return true;
      }
      return false;
    },
  },
  mounted: function() {
    /* sp panel */
    $(".panel").on("click", function() {
      // console.log("user:panel_click");
      $(".menu-trigger, header nav").toggleClass("active");
      $("nav .nav-area").slideToggle();
      $(".overlay").fadeToggle("slow");
    });
    $(".overlay").on("click", function() {
      $(".overlay, nav .nav-area").fadeToggle("slow");
      $(".menu-trigger, header nav").removeClass("active");
    });
  },

  methods: {
    onLogout: function() {
      console.log("logout");
      const self = this;
      const params = new URLSearchParams();
      this.$store.dispatch("logout");
      this.$store.commit("RESET");
      this.$axios
        .post(`/srv/api/logout`, params, {
          withCredentials: true
        })
        .then(response => {
          const data = response.data;
          if (data.status !== undefined) {
            if (data.status === "success") {
              console.log("success");
              self.$router.push("/login");
            } else {
              console.log("error");
              self.$router.push("/login");
            }
          } else {
            console.log("error");
            self.$router.push("/login");
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style>
/* body {
  font-size: 14px;
  font-size: 1.0rem;
  font-weight: 500;
  line-height: 1.6;
  position: relative;
  -webkit-text-size-adjust: 100%;
  -moz-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -o-text-size-adjust: 100%;
  text-size-adjust: 100%;
  text-align: left;
  width: 100%;
  color: #4e4d4d;
} */
</style>

